import {
  NgModule,
} from '@angular/core';
import {
  OrderStoreModule,
} from '@des/store/order';
import {
  UiStatusStoreModule,
} from '@refx/shared-store';

@NgModule({
  imports: [
    UiStatusStoreModule,
    OrderStoreModule
  ]
})
export class MetaConnectModule {}
